@if (isLoading) {
  <div class="loading-wrapper">
    <mat-progress-spinner
      color="primary"
      mode="indeterminate"
      diameter="32"></mat-progress-spinner>
  </div>
} @else {
  <div class="icon icon-red">
    <i class="fa-regular fa-calendar-xmark"></i>
  </div>
  <span class="font-medium-title-large">Buchung stornieren</span>
  <span class="font-regular-body-large">
    Beschreibe, warum die Buchung storniert wird.
  </span>
  <div class="input-simple align-self-stretch">
    <div class="input-label">Storno Typ</div>
    <p-select
      id="cancel-type"
      [options]="selectOptions"
      [(ngModel)]="selectedOption"
      [showClear]="true"
      appendTo="body"
      placeholder="Storno Typ auswählen" />
  </div>
  @if (errorMessage) {
    <div class="inwi-text-error font-regular-label-large">
      {{ errorMessage }}
    </div>
  }
  <div class="flex-r gap-16 justify-center padding-top-16">
    <button
      type="button"
      class="inwi-text-button-large-secondary"
      (click)="closeDialog(false)">
      <div class="button-content">
        <div class="button-text">Abbrechen</div>
      </div>
    </button>
    <button
      type="button"
      (click)="closeDialog(true)"
      class="inwi-text-button-large-primary">
      <div class="button-content">
        <div class="button-text">Stornieren</div>
      </div>
    </button>
  </div>
}
